import axios, { AxiosRequestConfig, AxiosInstance, InternalAxiosRequestConfig, Method } from 'axios'

import { AuthManagerInstance } from 'utils/auth/AuthManager'
import { config } from 'lib/config'

declare module 'axios' {
  interface InternalAxiosRequestConfig {
    suppressAuth?: boolean
  }
}

interface MakeRequestParams {
  type: Method
  requestUrl: string
  requestData?: any
  axiosOptions?: AxiosRequestConfig
}

interface ExtendedAxiosInstance extends AxiosInstance {
  makeRequest: (params: MakeRequestParams) => Promise<any>
}

const apiConfig: AxiosRequestConfig = {
  baseURL: `https://${config.API_BASE_URL}/api`,
  responseType: 'json',
}

export const API = axios.create(apiConfig) as ExtendedAxiosInstance

API.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (config.suppressAuth) {
    return config
  }

  if (AuthManagerInstance.authenticated) {
    config.headers.set('Authorization', `Bearer ${AuthManagerInstance.getToken()}`)
  }

  return config
})

API.makeRequest = ({ type, requestUrl, requestData, axiosOptions }: MakeRequestParams) => {
  let authPromise: Promise<any> = Promise.resolve(true)

  if (AuthManagerInstance.authenticated) {
    // NOTE: If tokens are being updated, wait for the request to finish
    if (AuthManagerInstance.updateTokenPromise) {
      authPromise = AuthManagerInstance.updateTokenPromise
    } else if (AuthManagerInstance.isAccessTokenExpired()) {
      // If tokens have expired, try to refresh them
      authPromise = AuthManagerInstance.updateTokens()
    }
  }

  return authPromise
    .catch(() => Promise.reject('Authorization failed'))
    .then(() =>
      API.request({
        ...axiosOptions,
        method: type,
        url: requestUrl,
        data: requestData,
      }),
    )
}
